var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{style:(_vm.backgroundStyle)},[_c('header',[(_vm.titleIcon)?_c('img',{staticClass:"title-icon",attrs:{"src":_vm.titleIcon,"alt":"icon"}}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.tips)?_c('i',{on:{"click":_vm.tip}}):_vm._e()]),_c('div',{staticClass:"content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }